import React from 'react';
import { CSSObject, FlexProps, Icon } from '@chakra-ui/react';
import { Prohibited } from '@styled-icons/foundation/Prohibited';
import { BetCardSchema } from '@/components/Betslip/components/BetCard/styles/BetCard.styles';

export const betCardStyles: BetCardSchema = {
  buttonBonusBetsProps: {
    display: 'flex',
    variant: 'secondary',
    h: '26px',
    px: '1.5',
    spanProps: {
      fontFamily: 'accent',
      textShadow: '0px 1px 2px rgba(0, 0, 0, 0.2)',
      fontWeight: 'normal',
      fontSize: '11px',
      pt: '0.5',
    },

    _disabled: {
      boxShadow: 'none',
      border: 'none',
      bg: 'blackAlpha.300',
      color: 'beta.50',
      opacity: '1',
      '& > span': {
        _first: {
          color: 'green.300',
          mr: '1',
        },
      },
    },

    sx: {
      '.chakra-button__icon': {
        display: 'none',
      },

      '&&[data-isbonusbet="true"]': {
        _disabled: {
          w: '100%',
          mt: '-3',
          bg: 'blackAlpha.600',
          borderRadius: 'none',
          borderBottomRadius: 'md',
          boxShadow: 'none',

          '.chakra-button__icon': {
            display: 'block',
            color: 'green.300',
            mr: '0.5',
          },

          span: {
            fontWeight: 'medium',
            fontSize: '2xs',
            fontFamily: 'body',
            color: 'white',
            pt: '0.5',
            textTransform: 'uppercase',
          },
        },
        bg: 'blackAlpha.600',
        color: 'gamma.300',
        boxShadow:
          '0px 0px 14px 0px rgba(0, 0, 0, 0.5) inset, 0px 1px 0px 0px rgba(255, 255, 255, 0.15)',
        px: '1.5',
        h: '26px',
        spanProps: {
          fontFamily: 'accent',
          fontWeight: 'normal',
          fontSize: '11px',
          pt: '0.5',
        },
      },
    },
  },
  buttonBetPropositionClosedProps: {
    variant: 'unstyled',
    bg: 'orange.500',
    boxShadow:
      '0px 2px 4px 0px rgba(0, 0, 0, 0.20), 0px 1px 0px 0px rgba(255, 255, 255, 0.20) inset',
    borderRadius: 'base',
    color: 'white',
    fontWeight: 'bold',
    fontSize: 'xs',
    px: '3',
    py: '2',
    paddingLeft: '12px',
    paddingRight: '12px',
  },
  buttonStakeProps: {
    fontFamily: 'body',
    fontSize: 'sm',
    fontWeight: 'extrabold',
    h: '42px',
    color: 'gamma.800',
    textShadow: '0px 1px 0px rgba(255, 255, 255, 0.4)',
    maxW: '47px',
  },
  flexWrapperMysteryRollover: {
    pb: '0',
    gap: '1',
  },
  flexWrapperMysteryBetFooterBetReview: {
    bg: 'blackAlpha.600',
    borderRadius: 'md',
    boxShadow:
      '0px 0px 14px 0px rgba(0, 0, 0, 0.5) inset, 0px 1px 0px 0px rgba(255, 255, 255, 0.15)',
    color: 'gamma.300',
    display: 'block',
    textAlign: 'left',
    p: '0.5',
    textTransform: 'capitalize',
    fontFamily: 'accent',
    fontWeight: 'normal',
    fontSize: 'xs',
    sx: {
      _last: {
        bg: 'beta.900',
        justifyContent: 'flex-start',
      },
    },
  },
  iconMysteryBetFooter: {
    mb: '0',
    mr: '2',
    mt: '-1',
  },
  iconBetCardSvgMysteryBet: {
    mb: '2',
  },
  flexWrapperMysteryBetFooterBetPlaced: {
    lineHeight: 'normal',
    p: '1',
    bg: 'beta.900',
    gap: '1',
    sx: {
      svg: {
        mr: '0',
        alignSelf: 'flex-start',
        mt: '0.5',
        ml: '0.5',
        transform: 'unset',
      },
    },
  },
  flexRaceInfoOverride: {
    lineHeight: 'normal',
  },
  spanBetOdds: {
    fontSize: 'xs',
    fontFamily: 'Roboto',
    fontWeight: 'semibold',
    pb: '0.5',
  },
  spanRaceInfo: {
    color: 'white',
    fontSize: 'xs',
    fontFamily: 'Roboto',
    fontWeight: 'semibold',
    mt: '1',
  },
  spanPropositionType: {
    color: 'alpha.700',
  },
  betCardSVG: {
    fill: 'alpha.600',
  },
};

export const betCardErrorFlexTextProps: FlexProps = {
  color: 'red.100',
  textShadow: '0px 1px 1px rgba(0, 0, 0, 0.35)',
  fontSize: 'xs',
  fontWeight: 'bold',
};

export const betCardErrorFlexProps: FlexProps = {
  boxShadow: '0px 3px 8px 0px rgba(0, 0, 0, 0.20)',
  color: 'red.100',
  bg: 'red.700',
  borderRadius: 'md',
  w: '95%',
  mx: 'auto',
  mt: '1',
  justifyContent: 'center',
  minH: '8',
  alignItems: 'center',
  px: '2',
  py: '1',
};

export const IconButtonThemed: CSSObject = {
  w: 'unset',
  minW: 'unset',
  justifyContent: 'right',
  color: 'white',
  transition: 'all .2s ease-in-out',
  _hover: {
    color: 'alpha.50',
  },
};

export const InfoBetOdds: CSSObject = {
  color: 'white',
  display: 'flex',
  fontWeight: 'semibold',
  fontSize: 'sm',
};

export const EventSubtitle: CSSObject = {
  textTransform: 'capitalize',
  fontSize: 'xs',
  fontWeight: 'medium',
  '&&': {
    color: 'white',
  },
};

export const ExoticsPlaceContainer: CSSObject = {
  fontWeight: 'bold',
  fontSize: 'xs',
  ml: '8',
};

export const TextExoticSelections: CSSObject = {
  fontSize: 'xs',
  fontWeight: 'medium',
};

export const FlexPlacedContainer: CSSObject = {
  p: '2',
};

export const BetPlaced: CSSObject = {
  bgGradient: 'linear(to-b, white, white)',
  boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.2), inset 0px 1px 0px #FFFFFF',
  color: 'gray.600',
  borderRadius: 'base',
  flexDirection: 'column',
  px: '2',
  py: '1.5',
};

export const TextExoticsLabel: CSSObject = {
  fontSize: 'xs',
  fontWeight: 'bold',
};

export const TextExoticsInfo: CSSObject = {
  fontSize: 'xs',
  fontWeight: 'normal',
};

export const BetPlacedRow: CSSObject = {
  justifyContent: 'flex-start',
};

export const TextPlacedLabel: CSSObject = {
  flex: '1',
};

export const IconPropositionClosed = () => (
  <Icon as={Prohibited} sx={{ boxSize: '5' }} />
);

export const EventRule: CSSObject = {
  color: 'white',
};

export const BetPropositionClosedError: CSSObject = {
  bg: 'rgb(0,112,215,0.7)',
  borderRadius: 'md',
  position: 'absolute',
  top: '-1px',
  left: '-1px',
  w: 'calc(100% + 2px)',
  h: 'calc(100% + 2px)',
  pb: '0',
  alignItems: 'center',
  justifyContent: 'center',
  overflow: 'hidden',
  zIndex: '3',
};

export const BetOdds: CSSObject = {
  mb: '2px',
};

export const DefaultStakeFlexbox: CSSObject = {
  gap: '1',
};

export const ExoticsFooterContainer: CSSObject = {
  pt: '0',
  pr: '2',
  pl: '10',
};
